import { Center, Loader, Paper } from '@mantine/core';
import React from 'react';

export default function CompanyPageLoadingSection() {
  return (
    <Paper variant="content" p="xxl">
      <Center h={400}>
        <Loader />
      </Center>
    </Paper>
  );
}
